// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];

// Only the legacy compatibility check uses these. Everywhere else the page type
// comes from getCanonicalPageType(), whose vocabulary is the site's own.
export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};

// FAB_EXPAND_DENYLIST is a denylist, not an allowlist — see .claude/context/fab.md
// "Why the auto-expand list is a denylist" for why.
export const FAB_EXPAND_DENYLIST = [
  'cart',
  'checkout',
  'checkout: opc',
];

// Page types where the page is still settling when the assistant mounts, so the
// expand waits longer.
export const EXTENDED_DELAY_PAGE_TYPES = [
  'pip',
  'bip',
  'ppip',
  'plp',
  'category',
  'search results',
];

export const OPEN_TYPES = {
  FAB_OPEN: 'FAB_OPEN',
  FAB_CLOSE: 'FAB_CLOSE',
  DEFAULT_MINIMIZED: 'DEFAULT_MINIMIZED',
  DEFAULT_OPEN: 'DEFAULT_OPEN',
  QUESTION_OPEN: 'QUESTION_OPEN',
  UNKNOWN: 'unknown'
};

export const MAGIC_APRON_CONTAINER_ID = 'DEF_MagicApronLoader';
export const MAGIC_APRON_ASSISTANT_ORIGIN = 'maa';

// Header -> loader: { drawerState } on the replaying lifeCycle bus (MAG4-859).
// See .claude/context/event-bus.md "Header entry point" for the absolute-state rationale.
export const UPDATE_DRAWER_STATE = 'magic-apron-assistant.update-drawer-state';

export const HEADER_ENTRY = {
  // Loader -> header. { available, drawerState }
  STATUS_EVENT: 'magic-apron-assistant.header-entry-status',
  // A header click reports as the assistant's own submit-click. The three below fill its
  // `question`: maa:header:<page type>:prepopulated:ask magic apron <open|close> click
  SUBMIT_EVENT: 'magic-apron-assistant.submit-click',
  // Analytics vocabulary. Kept separate from ORIGIN_HEADER, an internal routing token, so a
  // rename there cannot rewrite a reported string.
  ENTRY_LOCATION: 'header',
  MESSAGE_ORIGIN: 'prepopulated',
  // Open and close are reported separately so analytics can count each interaction.
  OPEN_LABEL: 'ask magic apron open click',
  CLOSE_LABEL: 'ask magic apron close click',
  ORIGIN_HEADER: 'header',
  ORIGIN_FAB: 'fab',
};
